@if (displayFormEmbed) {
  <div>
    <t-action-iframe-embed [formMinHeight]="550" [sourceURL]="formURL" />
  </div>
} @else {
  <t-moc-training-view (triggerFormEmbed)="switchToFormEmbed()" />
}
